<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <div class="">
            <h1 class="title-view">
              {{ formatDestinationTypeLabel(destinationType) }}
            </h1>

            <div class="box-id">
              <span class="number-id">
                {{ formatDestinationName(destinationType, destination) }}
              </span>
              <span class="ml-2 mr-2">|</span>
              <div class="status-tab">
                <div
                  class="badge-status d-inline-flex align-items-center"
                  :class="generateStatusClass(destinationStatus)"
                >
                  {{ formatDestinationStatus(destinationStatus) }}
                </div>

                <div
                  class="badge-status d-inline-flex align-items-center ml-2"
                  :class="
                    generateVisibilityStatusClass(destination.visibilityStatus)
                  "
                >
                  {{ formatVisibilityStatus(destination.visibilityStatus) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <a
              class="btn btn-outline-neutral d-inline-flex min-button no-mb ml-2"
              v-if="
                destination.visibilityStatus === 'PUBLISHED' && mode === 'view'
              "
              :href="generateWebViewLink(destinationType)"
              target="_blank"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">Web View</strong>
            </a>

            <base-button
              type="outline-neutral"
              class="min-button no-mb ml-2"
              @click="mode = 'view'"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1"></i> View
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb ml-2"
              v-if="mode === 'view'"
            >
              <i class="flaticon-pencil"></i> Edit
            </base-button>

            <base-button
              type="primary"
              class="min-button no-mb"
              @click="saveDestination(destinationId)"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-floppy-disk"></i> Save
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile forms mb-5">
      <tabs
        tabNavClasses="tabs-home justify-content-around tab-profiles"
        :value="tabActive"
        @changeTabActive="changeTabActive"
        type="primary"
      >
        <tab-pane
          class="tabs-home-content"
          id="Overview"
          title="Overview"
          ref="Overview"
        >
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row" v-if="mode === 'view'">
                <div
                  class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                >
                  <div class="card" v-if="destinationType == 'CITY'">
                    <h2 class="subtitle mb-2">City</h2>
                    <div class="row">
                      <div
                        class="col-xl-6 col-lg-6 col-md-46 col-sm-6 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">Name</span>
                          <span class="content-block">
                            {{ destination.city || "-" }}
                          </span>
                        </div>
                      </div>

                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">Slug</span>
                          <span class="content-block">
                            {{ destination.slug || "-" }}
                          </span>
                        </div>
                      </div>
                      <div
                        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">IATA Code</span>
                          <span class="content-block">
                            {{ destination.iata_code || "-" }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                >
                  <div class="card" v-if="destinationType == 'CITY'">
                    <h2 class="subtitle mb-2">State</h2>
                    <div class="row">
                      <div
                        class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">State</span>
                          <span class="content-block"
                            >{{ destination.state.name || "-" }}
                          </span>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">ISO State Code</span>
                          <span class="content-block"
                            >{{ destination.state.code || "-" }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                >
                  <div class="card">
                    <h2 class="subtitle mb-2">Country</h2>
                    <div class="row">
                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">Name</span>
                          <span class="content-block"
                            >{{ destination.country.name || "-" }}
                          </span>
                        </div>
                      </div>

                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">Slug</span>
                          <span class="content-block"
                            >{{ destination.country.slug || "-" }}
                          </span>
                        </div>
                      </div>

                      <div
                        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">ISO Country Code</span>
                          <span class="content-block"
                            >{{ destination.country.code || "-" }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 box-flex"
                >
                  <div class="card">
                    <h2 class="subtitle mb-2">Location</h2>
                    <div class="row">
                      <div
                        v-if="destinationType === 'CITY'"
                        class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">Latitude</span>
                          <span class="content-block"
                            >{{ destination.location.lat || "-" }}
                          </span>
                        </div>
                      </div>

                      <div
                        v-if="destinationType === 'CITY'"
                        class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">Longitude</span>
                          <span class="content-block"
                            >{{ destination.location.lng || "-" }}
                          </span>
                        </div>
                      </div>

                      <div
                        v-if="destinationType === 'CITY'"
                        class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">TimeZone</span>
                          <span class="content-block"
                            >{{ destination.time_zone || "-" }}
                          </span>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-4 col-md-6 col-sm-4 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">Language Name</span>
                          <span class="content-block"
                            >{{ destination.languages[0].name || "-" }}
                          </span>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-4 col-md-6 col-sm-4 col-12 box-flex"
                      >
                        <div class="data-block">
                          <span class="title-block">Language Code</span>
                          <span class="content-block"
                            >{{ destination.languages[0].code || "-" }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="mode === 'edit'">
                <div
                  class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
                >
                  <div class="card" v-if="destinationType == 'CITY'">
                    <h2 class="subtitle mb-3">City</h2>
                    <div class="row">
                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="$v.destination.city.$model"
                          label="Name"
                          placeholder="Name"
                          id="CITY"
                          name="CITY"
                          maxlength="100"
                          :error="
                            !$v.destination.city.minLength ||
                            $v.destination.city.$error
                              ? `Enter from ${$v.destination.city.$params.minLength.min} to ${$v.destination.city.$params.maxLength.max} characters.`
                              : ''
                          "
                          :disabled="!canUserUpdate"
                          :readonly="!canUserUpdate"
                        >
                        </base-input>
                      </div>

                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-slug
                          v-model="$v.destination.slug.$model"
                          label="Slug"
                          placeholder="slug"
                          id="slug"
                          name="slug"
                          maxlength="100"
                          format="lowercase"
                          :tooltip="true"
                          titleTooltip="City Slug"
                          contentTooltip='<span>A "slug" is the final part of a URL that uniquely identifies the destination page, be it country or city..</span>'
                          :error="
                            !$v.destination.slug.minLength ||
                            $v.destination.slug.$error
                              ? `Enter from ${$v.destination.slug.$params.minLength.min} to ${$v.destination.slug.$params.maxLength.max} characters.`
                              : ''
                          "
                          :disabled="!canUserUpdate"
                          :readonly="!canUserUpdate"
                        >
                        </base-input>
                      </div>

                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="$v.destination.iata_code.$model"
                          label="IATA Code"
                          placeholder="iata_code"
                          id="iata_code"
                          name="iata_code"
                          maxlength="3"
                          :error="
                            $v.destination.iata_code.$error
                              ? `Enter from ${$v.destination.iata_code.$params.minLength.min} to ${$v.destination.iata_code.$params.maxLength.max} characters.`
                              : ''
                          "
                        >
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
                >
                  <div class="card" v-if="destinationType == 'CITY'">
                    <h2 class="subtitle mb-3">State</h2>
                    <div class="row">
                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="$v.destination.state.name.$model"
                          label="Name"
                          placeholder="Name"
                          id="state"
                          name="state"
                          maxlength="100"
                          :error="
                            !$v.destination.state.name.minLength ||
                            $v.destination.state.name.$error
                              ? `Enter from ${$v.destination.state.name.$params.minLength.min} to ${$v.destination.state.name.$params.maxLength.max} characters.`
                              : ''
                          "
                          :disabled="!canUserUpdate"
                          :readonly="!canUserUpdate"
                        >
                        </base-input>
                      </div>

                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="$v.destination.state.code.$model"
                          label="ISO State Code"
                          placeholder="iso_code"
                          id="iso_statecode"
                          name="iso_statecode"
                          maxlength="6"
                          :error="
                            !$v.destination.state.code.minLength ||
                            $v.destination.state.code.$error
                              ? `Enter from ${$v.destination.state.code.$params.minLength.min} to ${$v.destination.state.code.$params.maxLength.max} characters.`
                              : ''
                          "
                        >
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
                >
                  <div class="card">
                    <h2 class="subtitle mb-3">Country</h2>
                    <div class="row">
                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="$v.destination.country.name.$model"
                          label="Name"
                          placeholder="Name"
                          id="country"
                          name="country"
                          maxlength="100"
                          :error="
                            !$v.destination.country.name.minLength ||
                            $v.destination.country.name.$error
                              ? `Enter from ${$v.destination.country.name.$params.minLength.min} to ${$v.destination.country.name.$params.maxLength.max} characters.`
                              : ''
                          "
                          :readonly="
                            destinationType === 'CITY' || !canUserUpdate
                          "
                          :disabled="
                            destinationType === 'CITY' || !canUserUpdate
                          "
                        >
                        </base-input>
                      </div>

                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-slug
                          v-model="$v.destination.country.slug.$model"
                          label="Country Slug"
                          placeholder="country_slug"
                          id="country_slug"
                          name="country_slug"
                          maxlength="100"
                          format="lowercase"
                          :tooltip="true"
                          titleTooltip="Country Slug"
                          contentTooltip='<span>A "slug" is the final part of a URL that uniquely identifies the destination page, be it country or city..</span>'
                          :error="
                            !$v.destination.country.slug.minLength ||
                            $v.destination.country.slug.$error
                              ? `Enter from ${$v.destination.country.slug.$params.minLength.min} to ${$v.destination.country.slug.$params.maxLength.max} characters.`
                              : ''
                          "
                          :readonly="
                            destinationType === 'CITY' || !canUserUpdate
                          "
                          :disabled="
                            destinationType === 'CITY' || !canUserUpdate
                          "
                        >
                        </base-input>
                      </div>

                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="$v.destination.country.code.$model"
                          label="ISO Country Code"
                          placeholder="iso country code"
                          id="iso_countrycode"
                          name="iso_countrycode"
                          maxlength="6"
                          :error="
                            !$v.destination.country.code.minLength ||
                            $v.destination.country.code.$error
                              ? `Enter from ${$v.destination.country.code.$params.minLength.min} to ${$v.destination.country.code.$params.maxLength.max} characters.`
                              : ''
                          "
                          readonly
                          disabled
                        >
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
                >
                  <div class="card">
                    <h2 class="subtitle mb-3">Location</h2>
                    <div class="row">
                      <div
                        v-if="destinationType === 'CITY'"
                        class="col-xl-4 col-lg-3 col-md-4 col-sm-4 col-12"
                      >
                        <base-input
                          v-model="$v.destination.location.lat.$model"
                          label="Latitude"
                          placeholder="Latitude"
                          id="latitude"
                          name="latitude"
                          maxlength="100"
                          :error="
                            $v.destination.location.lat.$error
                              ? `Enter a valid latitude.`
                              : ''
                          "
                          :disabled="!canUserUpdate"
                          :readonly="!canUserUpdate"
                        >
                        </base-input>
                      </div>

                      <div
                        v-if="destinationType === 'CITY'"
                        class="col-xl-4 col-lg-3 col-md-4 col-sm-4 col-12"
                      >
                        <base-input
                          v-model="$v.destination.location.lng.$model"
                          label="Longitude"
                          placeholder="longitude"
                          id="longitude"
                          name="longitude"
                          maxlength="100"
                          :error="
                            $v.destination.location.lng.$error
                              ? `Enter a valid longitude.`
                              : ''
                          "
                          :disabled="!canUserUpdate"
                          :readonly="!canUserUpdate"
                        >
                        </base-input>
                      </div>

                      <div
                        v-if="destinationType === 'CITY'"
                        class="col-xl-4 col-lg-3 col-md-4 col-sm-4 col-12"
                      >
                        <base-input
                          v-model="$v.destination.time_zone.$model"
                          label="TimeZone"
                          placeholder="TimeZone"
                          id="TimeZone"
                          name="TimeZone"
                          maxlength="45"
                          :error="
                            !$v.destination.time_zone.minLength ||
                            $v.destination.time_zone.$error
                              ? `Enter from ${$v.destination.time_zone.$params.minLength.min} to ${$v.destination.time_zone.$params.maxLength.max} characters.`
                              : ''
                          "
                          :disabled="!canUserUpdate"
                          :readonly="!canUserUpdate"
                        >
                        </base-input>
                      </div>

                      <div class="col-xl-6 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="
                            $v.destination.languages.$each[0].name.$model
                          "
                          label="Language Name"
                          placeholder="Language Name"
                          id="LanguageName"
                          name="LanguageName"
                          maxlength="45"
                          :error="
                            !$v.destination.languages.$each[0].name.minLength ||
                            $v.destination.languages.$each[0].name.$error
                              ? `Enter from ${$v.destination.languages.$each[0].name.$params.minLength.min} to ${$v.destination.languages.$each[0].name.$params.maxLength.max} characters.`
                              : ''
                          "
                        >
                        </base-input>
                      </div>

                      <div class="col-xl-4 col-lg-3 col-md-4 col-sm-6 col-12">
                        <base-input
                          v-model="
                            $v.destination.languages.$each[0].code.$model
                          "
                          label="Language Code"
                          placeholder="Language Code"
                          id="Languagecode"
                          name="Languagecode"
                          maxlength="6"
                          :error="
                            !$v.destination.languages.$each[0].code.minLength ||
                            $v.destination.languages.$each[0].code.$error
                              ? `Enter from ${$v.destination.languages.$each[0].code.$params.minLength.min} to ${$v.destination.languages.$each[0].code.$params.maxLength.max} characters.`
                              : ''
                          "
                        >
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
            >
              <div class="card">
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-4"
                  >
                    <base-button
                      type=""
                      class="min-button btn-line-danger abso-map-3 abso-10"
                      @click="resetPolygonPaths"
                      v-if="mode === 'edit' && destinationType === 'CITY'"
                    >
                      <i class="flaticon-eraser"></i> Reset Area
                    </base-button>

                    <GoogleMaps
                      :location="
                        destinationType === 'CITY' ? destination.location : null
                      "
                      :paths="coordinates"
                      :resetPaths="resetPaths"
                      :autoCompleteElementId="'autocomplete'"
                      :allowPolygonDraw="
                        mode === 'edit' && destinationType === 'CITY'
                      "
                      @updateCoordinates="onUpdateCoordinates"
                      class="test"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <tab-pane class="tabs-home" id="Content" title="Content" ref="Content">
          <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
              <div class="card">
                <div class="row">
                  <div class="col-xl-12">
                    <h2 class="subtitle mb-2">Images</h2>
                    <div class="row">
                      <div
                        class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12 pb-3"
                      >
                        <div class="data-block">
                          <span class="title-block"
                            >Cover
                            <el-popover
                              placement="top"
                              trigger="hover"
                              width="300"
                              class="curp"
                              v-if="mode === 'edit'"
                            >
                              <ul class="ul-pop">
                                <li>Image in colors</li>
                                <li>Required Dimensions: 1600 x 700 px</li>
                                <li>Maximum Size: 2MB</li>
                                <li>Allowed Formats: JPG, PNG</li>
                              </ul>
                              <div class="badge badge-primary" slot="reference">
                                <span>?</span>
                              </div>
                            </el-popover>
                          </span>
                        </div>

                        <div class="destination-load-cover imageload3">
                          <div class="image">
                            <div class="img-destination-cover">
                              <LazyImage
                                v-if="destination.article.image"
                                :src="destination.article.image"
                                imgClasses="cover-default"
                                beforeClasses=""
                              />

                              <img
                                v-else
                                :src="noPreview"
                                class="cover-default"
                              />
                            </div>
                          </div>

                          <div
                            class="contentfile3 destination-cover"
                            v-if="mode === 'edit'"
                          >
                            <base-dropdown>
                              <base-button
                                slot="title-container"
                                type="primary"
                                class="dropdown-toggle btn-icon-only buttonfiles3"
                              >
                                <i class="flaticon-camera mr-0"></i>
                              </base-button>
                              <span class="dropdown-item">
                                <base-input
                                  class="filebutton3"
                                  type="file"
                                  name="file-cover"
                                  id="file-cover"
                                  :accesskey="'cover'"
                                  enctype="multipart/form-data"
                                  accept="image/jpeg, image/jpg, image/png"
                                  @change="onSelectFile('COVER', $event)"
                                ></base-input>
                                Upload Image
                              </span>
                              <span
                                class="dropdown-item"
                                v-if="destination.article.image"
                                @click="removeImage('COVER')"
                                ><i class="flaticon-delete"></i>
                              </span>
                            </base-dropdown>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12 pb-3"
                      >
                        <div class="data-block">
                          <span class="title-block"
                            >Thumbnail
                            <el-popover
                              placement="top"
                              trigger="hover"
                              width="300"
                              class="curp"
                              v-if="mode === 'edit'"
                            >
                              <ul class="ul-pop">
                                <li>Image in colors</li>
                                <li>Required Dimensions: 480 x 360 px</li>
                                <li>Maximum Size: 2MB</li>
                                <li>Allowed Formats: JPG, PNG</li>
                              </ul>
                              <div class="badge badge-primary" slot="reference">
                                <span>?</span>
                              </div>
                            </el-popover>
                          </span>
                        </div>

                        <div class="image-load-default-min imageload3">
                          <div class="image">
                            <div class="img-destination-cover">
                              <LazyImage
                                v-if="destination.article.thumbnail"
                                :src="destination.article.thumbnail"
                                imgClasses="cover-default"
                                beforeClasses=""
                              />

                              <img
                                v-else
                                :src="noPreview"
                                class="cover-default"
                              />
                            </div>
                          </div>
                          <div
                            class="contentfile3 destination-thumb"
                            v-if="mode === 'edit'"
                          >
                            <base-dropdown>
                              <base-button
                                slot="title-container"
                                type="primary"
                                class="dropdown-toggle btn-icon-only buttonfiles3"
                              >
                                <i class="flaticon-camera mr-0"></i>
                              </base-button>
                              <span class="dropdown-item">
                                <base-input
                                  class="filebutton3"
                                  type="file"
                                  name="file-thumbnail"
                                  id="file-thumbnail"
                                  :accesskey="'thumbnail'"
                                  enctype="multipart/form-data"
                                  accept="image/jpeg, image/jpg, image/png"
                                  @change="onSelectFile('THUMBNAIL', $event)"
                                ></base-input>
                                Upload Image
                              </span>
                              <span
                                class="dropdown-item"
                                v-if="destination.article.thumbnail"
                                @click="removeImage('THUMBNAIL')"
                                ><i class="flaticon-delete"></i>
                              </span>
                            </base-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12"
                    v-if="mode === 'edit'"
                  >
                    <WSelect
                      placeholder="Web Status"
                      label="Web Status"
                      v-model="$v.destination.visibilityStatus.$model"
                      filterable
                      id="webStatus"
                      :error="
                        $v.destination.visibilityStatus.$error
                          ? 'Please select a web status.'
                          : ''
                      "
                      :tooltip="true"
                      contentTooltip="<span>This allows you to show or not the destination article on the Rhomtrip website <strong>https://rhomtrip.com/destinations</strong>.</span>"
                    >
                      <el-option
                        v-for="option in statusWeb"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-if="mode === 'edit'"
                      v-model="lastUpdatedAt"
                      label="Last Updated"
                      placeholder="Last Updated"
                      id="date"
                      name="date"
                      disabled
                      readonly
                    />

                    <div class="data-block" v-else>
                      <span class="title-block">Last Updated</span>
                      <span class="content-block capitalize">
                        {{ lastUpdatedAt || "Not Available" }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
              <div class="row">
                <div class="col-12">
                  <div class="card pb-4" v-if="mode === 'view'">
                    <h2 class="subtitle mb-2">Content</h2>
                    <div class="row">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                      >
                        <div class="data-block">
                          <span class="title-block">Short Description</span>
                          <span class="content-block">{{
                            destination.article.description || "Not Provided"
                          }}</span>
                        </div>

                        <hr />
                      </div>

                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                      >
                        <div class="data-block">
                          <span class="title-block">Article</span>
                          <span
                            class="content-block"
                            v-html="
                              destination.article.content || 'Not Provided'
                            "
                          >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="card pb-4" v-if="mode === 'edit'">
                    <h2 class="subtitle mb-3">
                      Content
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          Add a content as it will be a part of the destination.
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </h2>
                    <div class="row">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3"
                        v-bind:class="{
                          'is-invalid':
                            $v.destination.article.description.$error
                        }"
                      >
                        <label
                          slot="label"
                          for="destination_description"
                          class="title-label"
                          >Short Description
                          <el-popover
                            placement="bottom"
                            trigger="hover"
                            width="350"
                            class="curp"
                          >
                            <span>
                              Add a short description of the destination
                            </span>
                            <div class="badge badge-primary" slot="reference">
                              ?
                            </div>
                          </el-popover></label
                        >

                        <el-input
                          v-model="$v.destination.article.description.$model"
                          placeholder="description"
                          id="destination_description"
                          name="destination_description"
                          tabindex="15"
                          maxlength="200"
                          type="textarea"
                          :autosize="{ minRows: 1, maxRows: 2 }"
                          show-word-limit
                        >
                        </el-input>

                        <div
                          v-if="$v.destination.article.description.$error"
                          class="invalid-feedback mt--1"
                        >
                          {{
                            $v.destination.article.description.$error
                              ? `Enter from ${$v.destination.article.description.$params.minLength.min} to ${$v.destination.article.description.$params.maxLength.max} characters.`
                              : ""
                          }}
                        </div>
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                        v-bind:class="{
                          'is-invalid': $v.destination.article.content.$error
                        }"
                      >
                        <label
                          slot="label"
                          for="destination_description"
                          class="title-label"
                          >Article
                          <el-popover
                            placement="bottom"
                            trigger="hover"
                            width="350"
                            class="curp"
                          >
                            <span>
                              Content of the destination article, it must
                              contain:

                              <ul class="ul-popover">
                                <li>Short explatation</li>
                                <li>What To See</li>
                                <li>Traditions and Celebrations</li>
                                <li>Nightlife</li>
                                <li>Main Attractions</li>
                                <li>Near</li>
                                <li>Hotels</li>
                              </ul>

                              <strong
                                class="curp ml-2"
                                v-clipboard:copy="
                                  generateChatGPTPromt(destinationType)
                                "
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onErrorCopy"
                              >
                                Copy ChatGPT promt Here
                                <i class="flaticon-copy link ml-1"></i
                              ></strong>
                            </span>
                            <div class="badge badge-primary" slot="reference">
                              ?
                            </div>
                          </el-popover></label
                        >

                        <el-input
                          v-model="$v.destination.article.content.$model"
                          placeholder="content"
                          id="destination_content"
                          name="destination_content"
                          maxlength="50000"
                          type="textarea"
                          :autosize="{ minRows: 20, maxRows: 40 }"
                          show-word-limit
                        >
                        </el-input>

                        <div
                          v-if="$v.destination.article.content.$error"
                          class="invalid-feedback"
                        >
                          Enter 200 to 50000 characters
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import lodash from "lodash";
import "flatpickr/dist/flatpickr.css";
import { Switch, Card, DatePicker } from "element-ui";
import Swal from "sweetalert2";
import { VueEditor } from "vue2-editor";
import GoogleMaps from "@/components/GoogleMap.vue";
import {
  required,
  minLength,
  maxLength,
  requiredIf
} from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import { goBack } from "@/helpers/commons.helpers";
import { handleApiError } from "@/core/services";
import { CountriesAPI, DestinationsAPI } from "@/core/api";
import {
  formatDestinationName,
  formatDestinationStatus,
  formatDestinationTypeLabel,
  formatLastUpdatedAt,
  formatVisibilityStatus,
  generateStatusClass,
  generateVisibilityStatusClass
} from "../services/format.services";
import {
  getFileExtension,
  getFileName,
  getFolderPathByDestinationType,
  uploadDestinationImage
} from "../services/images.services";
import { isUserAuthorized } from "../../../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "Destination",
  data() {
    return {
      destination: {
        country: {
          code: "",
          name: "",
          slug: ""
        },
        state: {
          code: "",
          name: "",
          slug: ""
        },
        city: "",
        slug: "",
        article: {
          image: "",
          thumbnail: "",
          description: "",
          content: ""
        },
        location: {
          lat: 0,
          lng: 0
        },
        time_zone: "",
        languages: [
          {
            code: "",
            name: ""
          }
        ],
        geometry: {
          type: "Polygon",
          coordinates: []
        },
        iata_code: "",
        visibilityStatus: "PENDING"
      },
      destinationStatus: "INACTIVE",
      destinationCopy: {},
      destinationType: "COUNTRY",
      statusWeb: [
        {
          label: "Pending Publication",
          value: "PENDING",
          icon: "text-warning"
        },
        {
          label: "Published",
          value: "PUBLISHED",
          icon: "text-success"
        }
      ],
      lastUpdatedAt: null,
      tabActive: "Overview",
      onSave: false,
      coordinates: [],
      resetPaths: false,
      noPreview: require("rhomtrip_assets/src/img/no-image-available.png"),
      mode: "view",
      WEB_RHOMTRIP: process.env.VUE_APP_RHOMTRIP
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Tools",
        to: "/tools"
      },
      {
        text: "Destinations",
        to: "/tools/destinations"
      },
      {
        text: "Destination Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.destinationType = this.$route.query.type || "CITY";
    this.destinationId = this.$route.params.id;
    await this.loadDestination(this.destinationType, this.destinationId);
    this.destinationCopy = lodash.cloneDeep(this.destination);
  },
  methods: {
    generateStatusClass,
    formatDestinationStatus,
    formatDestinationName,
    formatDestinationTypeLabel,
    generateVisibilityStatusClass,
    formatVisibilityStatus,
    formatLastUpdatedAt,
    /**
     * Load destination details based on type
     * @param {string} destinationType - Type of destination ("CITY" or "COUNTRY")
     * @param {string} destinationId - ID of the destination
     */
    async loadDestination(destinationType, destinationId) {
      if (destinationType === "CITY") {
        this.setLoad(true);
        await this.getCityById(destinationId);
        this.setLoad(false);
      } else {
        this.setLoad(true);
        await this.getCountryById(destinationId);
        this.setLoad(false);
      }
      return;
    },
    /**
     * Fetch city details by ID
     * @param {string} id - City ID
     */
    async getCityById(id) {
      try {
        const { data } = await DestinationsAPI.getDestinationById(
          id,
          this.sesion.token
        );
        if (data.status) {
          let destination = data.data;
          // City Information
          this.destination.iata_code = destination.iata_code;
          this.destination.city = destination.city; // City
          this.destination.slug = destination.slug; // City Slug
          this.destination.state = destination.state;

          // Country Information
          this.destination.country = destination.country;

          // Language Information
          if (destination.languages.length > 0) {
            this.destination.languages = destination.languages;
          }

          // Location Information
          this.destination.location = destination.location;
          this.destination.geometry = destination.geometry;
          this.coordinates = destination.geometry.coordinates;

          // Geometry Information
          this.destination.time_zone = destination.time_zone; // Time Zone
          this.destination.article = destination.article;
          this.destination.article.content = destination.article.content.replace(
            />\s+</g,
            "><"
          );
          this.destinationStatus = destination.status || "ACTIVE";
          this.destination.visibilityStatus =
            destination.visibilityStatus || "PENDING";

          this.lastUpdatedAt = this.formatLastUpdatedAt(destination.updatedAt);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    /**
     * Fetch country details by ID
     * @param {string} id - Country ID
     */
    async getCountryById(id) {
      try {
        const { data } = await CountriesAPI.getCountryById(
          id,
          this.sesion.token
        );
        if (data.status) {
          let country = data.data;
          // Country Information
          this.destination.country.code = country.code;
          this.destination.country.name = country.name;
          this.destination.country.slug = country.slug;

          // Language Information
          if (country.languages.length > 0) {
            this.destination.languages = country.languages;
          }

          // Article Information
          this.destination.article = country.article;
          this.destination.article.content = country.article.content.replace(
            />\s+</g,
            "><"
          );
          // Status Information
          this.destinationStatus = country.status || "ACTIVE";
          this.destination.visibilityStatus =
            country.visibilityStatus || "PENDING";

          this.lastUpdatedAt = this.formatLastUpdatedAt(country.updatedAt);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    /**
     * Save destination (city or country) based on type
     * @param {string} id - Destination ID
     * @param {string|null} route - Optional route to navigate after saving
     */
    async saveDestination(id, route = null) {
      if (!this.$v.destination.$invalid) {
        if (this.destinationType == "CITY") {
          let city = this.generateCityData(this.destination);
          await this.updateCityById(id, city);
        } else if (this.destinationType == "COUNTRY") {
          let country = this.generateCountryData(this.destination);
          await this.updateCountryById(id, country);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "Invalid destination type.",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$v.destination.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    /**
     * Update city details by ID
     * @param {string} id - City ID
     * @param {object} destination - City data to update
     * @param {string|null} route - Optional route to navigate after saving
     */
    async updateCityById(id, destination, route, action) {
      try {
        this.setLoad(true);
        let { data } = await DestinationsAPI.updateDestinationById(
          id,
          destination,
          this.sesion.token
        );
        this.setLoad(false);
        this.onSave = true;
        if (data.status) {
          let city = data.data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The destination has been Saved",
            icon: "flaticon-check-mark"
          });
          this.$router.push(route ? route : "/tools/destinations");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.onSave = true;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    /**
     * Update country details by ID
     * @param {string} id - Country ID
     * @param {object} country - Country data to update
     * @param {string|null} route - Optional route to navigate after saving
     */
    async updateCountryById(id, country, route, action) {
      try {
        this.setLoad(true);
        let { data } = await CountriesAPI.updateCountryById(
          id,
          country,
          this.sesion.token
        );
        this.setLoad(false);
        this.onSave = true;
        if (data.status) {
          let country = data.data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The country has been Saved",
            icon: "flaticon-check-mark"
          });
          this.$router.push(route ? route : "/tools/destinations");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.onSave = true;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    /**
     * Generate city data object for API
     * @param {object} destination - City data
     * @returns {object} - Formatted city data
     */
    generateCityData(destination) {
      return {
        iata_code: destination.iata_code,
        city: destination.city,
        slug: destination.slug,
        state: {
          code: destination.state.code,
          name: destination.state.name,
          slug: destination.state.slug
        },
        country: {
          code: destination.country.code,
          name: destination.country.name,
          slug: destination.country.slug
        },
        location: {
          lat: destination.location.lat,
          lng: destination.location.lng
        },
        languages: destination.languages,
        time_zone: destination.time_zone,
        article: {
          content: destination.article.content,
          description: destination.article.description,
          image: destination.article.image,
          thumbnail: destination.article.thumbnail
        },
        geometry: destination.geometry,
        visibilityStatus: destination.visibilityStatus
      };
    },
    /**
     * Generate country data object for API
     * @param {object} destination - Country data
     * @returns {object} - Formatted country data
     */
    generateCountryData(destination) {
      return {
        code: destination.country.code,
        name: destination.country.name,
        slug: destination.country.slug,
        article: {
          content: destination.article.content,
          description: destination.article.description,
          image: destination.article.image,
          thumbnail: destination.article.thumbnail
        },
        languages: destination.languages,
        visibilityStatus: destination.visibilityStatus
      };
    },
    /**
     * Handle API errors and display notifications
     * @param {object} error - Error object from API
     * @param {string} message - Default error message
     */
    handleError(error, message) {
      handleApiError(this, error, message);
    },
    /**
     * Change the active tab
     * @param {string} tabActive - The tab to activate
     */
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    /**
     * Navigate to the previous page
     */
    goToPreviousPage() {
      goBack(this);
    },
    /**
     * Confirm before resetting coordinates
     */
    async resetPolygonPaths() {
      let { value } = await Swal.fire({
        title: "Reset Destination Area",
        text: "Are you sure do you want to reset this Destination Area?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.resetPaths = true;
      }
    },
    /**
     * Save coordinates from the map
     * @param {Array} coordinates - Array of coordinate objects
     */
    onUpdateCoordinates(coordinates) {
      if (coordinates.length === 0) {
        this.destination.geometry.coordinates = [];
        this.resetPaths = false;
        return;
      }
      this.destination.geometry.type = "Polygon";
      this.destination.geometry.coordinates = this.mapCoordinates(coordinates);
    },
    /**
     * Parse coordinates into latitude and longitude objects
     * @param {Array} coordinates - Array of coordinate objects
     * @returns {Array} - Parsed coordinates
     */
    mapCoordinates(coordinates) {
      return coordinates.map(function(element) {
        return { lat: element.lat, lng: element.lng };
      });
    },
    /**
     * Remove image from destination article
     * @param {string} type - Type of image to remove ("COVER" or "THUMBNAIL")
     */
    removeImage(type) {
      if (type === "COVER") {
        this.destination.article.image = "";
      } else if (type === "THUMBNAIL") {
        this.destination.article.thumbnail = "";
      }
    },
    /**
     * Handle file selection for image upload
     * @param {string} imageType - Type of image ("COVER" or "THUMBNAIL")
     * @param {Event} event - File input change event
     */
    async onSelectFile(imageType, event) {
      const [file] = event.target.files;
      const fileSizeRestriction =
        imageType === "COVER" ? 2 * 1024 * 1024 : 2 * 480 * 360;
      if (file.size > fileSizeRestriction) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            imageType === "COVER"
              ? "The image can't be larger than 2MB or exceed 1600px x 700px dimensions"
              : "The image can't be larger than 2MB or exceed 480px x 360px dimensions",
          icon: "flaticon-remove"
        });
        return;
      }

      const folderPath = getFolderPathByDestinationType(this.destinationType);
      const destinationSlug = this.getDestinationSlug(this.destinationType);
      const fileName = getFileName(
        imageType,
        destinationSlug,
        getFileExtension(file.name)
      );
      if (imageType === "COVER") {
        let urlFile = await uploadDestinationImage(folderPath, fileName, file);
        this.destination.article.image = urlFile;
      }

      if (imageType === "THUMBNAIL") {
        let urlFile = await uploadDestinationImage(folderPath, fileName, file);
        this.destination.article.thumbnail = urlFile;
      }

      return;
    },
    /**
     * Get destination slug based on type
     * @param {string} destinationType - Type of destination ("CITY" or "COUNTRY")
     * @returns {string} - Destination slug
     */
    getDestinationSlug(destinationType) {
      return destinationType === "CITY"
        ? this.destination.slug
        : this.destination.country.slug;
    },
    /**
     * Generate web view link for the destination
     * @param {string} destinationType - Type of destination ("CITY" or "COUNTRY")
     * @returns {string} - Web view link
     */
    generateWebViewLink(destinationType) {
      if (destinationType === "CITY") {
        return `${this.WEB_RHOMTRIP}/destinations/${this.destination.country.slug}/${this.destination.slug}`;
      } else {
        return `${this.WEB_RHOMTRIP}/destinations/${this.destination.country.slug}`;
      }
    },
    /**
     * Generate ChatGPT prompt for the destination
     * @param {string} destinationType - Type of destination ("CITY" or "COUNTRY")
     * @returns {string} - ChatGPT prompt
     */
    generateChatGPTPromt(destinationType) {
      let destination =
        destinationType === "CITY"
          ? `${this.destination.city} of ${this.destination.country.name}`
          : `${this.destination.country.name} Country`;
      return `As the best travel blog writer in the world, create a summary of ${destination} in 4 paragraphs of 4 lines each using HTML p tags. Then, additionally add the following: Add the following titles, each with an HTML h2 tag: "What To See", "Traditions and Celebrations", "Nightlife", "Main Attractions", "Near", "Hotels", "Conferences" and add to each title a summary in a paragraph of 4 lines referring to this title, using HTML p tags. Additionally, for the titles "Hotels" and "Conferences", add a list of 3 to 5 of the most relevant hotels-conference venues with ul-li tags. For everything above, only use p, ul, li, or h2 tags as requested, keep everything written in friendly language with the best spelling and grammar, and in U.S. English.`;
    },
    /**
     * Notification for successful copy to clipboard
     */
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    /**
     * Notification for failed copy to clipboard
     */
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    /**
     * Detect changes in the destination form
     * @param {Object} to - Route object for the target route
     * @param {Object} from - Route object for the current route
     * @param {Function} next - Function to call to proceed to the next middleware
     */
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.destination, this.destinationCopy);
      if (!isEqual && !this.onSave) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The destination has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          cancelButtonClass: "btn btn-secondary btn-small-one",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveDestination(this.destination.id, to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    /**
     * Check if the destination module is included in the modules array
     * @param {Array} modules - Array of module names
     */
    isInDestinationsModule(modules = []) {
      if (!modules.includes("destinations")) {
        this.setDestinationSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setDestinationSearchCriteria"
    ])
  },
  components: {
    [Switch.name]: Switch,
    [Card.name]: Card,
    [DatePicker.name]: DatePicker,
    flatPicker,
    WSelect,
    VueEditor,
    GoogleMaps
  },
  computed: {
    ...mapGetters(["sesion", "sigout", "userRole"]),
    canUserUpdate() {
      return isUserAuthorized("DESTINATIONS", this.userRole, "UPDATE");
    }
  },
  validations: {
    destination: {
      country: {
        slug: {
          required: requiredIf(function(value) {
            return this.destinationType === "COUNTRY";
          }),
          maxLength: maxLength(100),
          minLength: minLength(2)
        },
        code: {
          required: requiredIf(function(value) {
            return this.destinationType === "COUNTRY";
          }),
          maxLength: maxLength(6),
          minLength: minLength(2)
        },
        name: {
          required: requiredIf(function(value) {
            return this.destinationType === "COUNTRY";
          }),
          minLength: minLength(2),
          maxLength: maxLength(100)
        }
      },
      state: {
        code: {
          required: requiredIf(function(value) {
            return false;
          }),
          maxLength: maxLength(6),
          minLength: minLength(2)
        },
        name: {
          required: requiredIf(function(value) {
            return this.destinationType === "CITY";
          }),
          maxLength: maxLength(100),
          minLength: minLength(2)
        }
      },
      slug: {
        minLength: minLength(2),
        maxLength: maxLength(100),
        required: requiredIf(function(value) {
          return this.destinationType === "CITY";
        })
      },
      iata_code: {
        required: requiredIf(function(value) {
          return this.destinationType === "CITY";
        }),
        minLength: minLength(3),
        maxLength: maxLength(3)
      },
      city: {
        required: requiredIf(function(value) {
          return this.destinationType === "CITY";
        }),
        minLength: minLength(2),
        maxLength: maxLength(100)
      },
      article: {
        content: {
          minLength: minLength(200),
          maxLength: maxLength(20000)
        },
        description: {
          minLength: minLength(50),
          maxLength: maxLength(160)
        }
      },
      visibilityStatus: {
        required
      },
      location: {
        lat: {
          required: requiredIf(function(value) {
            return this.destinationType === "CITY";
          })
        },
        lng: {
          required: requiredIf(function(value) {
            return this.destinationType === "CITY";
          })
        }
      },
      languages: {
        required: false,
        $each: {
          name: {
            minLength: minLength(2),
            maxLength: maxLength(45)
          },
          code: {
            minLength: minLength(2),
            maxLength: maxLength(6)
          }
        }
      },
      time_zone: {
        required: requiredIf(function(value) {
          return this.destinationType === "CITY";
        }),
        minLength: minLength(2),
        maxLength: maxLength(45)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInDestinationsModule(to.meta.modules);
    this.detectChanges(to, from, next);
  }
};
</script>
